import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, vShow as _vShow, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-5586e1f3"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0,
  class: "header"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, null, -1));
const _hoisted_3 = [_hoisted_2];
const _hoisted_4 = {
  class: "logo"
};
const _hoisted_5 = {
  key: 0
};
const _hoisted_6 = ["src"];
const _hoisted_7 = {
  class: "bgIcon"
};
const _hoisted_8 = ["src"];
const _hoisted_9 = {
  class: "search2"
};
const _hoisted_10 = {
  class: "cp_con"
};
const _hoisted_11 = {
  id: "custom-show-hide-example2"
};
const _hoisted_12 = {
  class: "menu_info_main"
};
const _hoisted_13 = {
  class: "scroll_cont"
};
const _hoisted_14 = {
  id: "custom-show-hide-example2",
  class: "menu2"
};
const _hoisted_15 = {
  class: "menu_info_main"
};
const _hoisted_16 = {
  class: "scroll_cont"
};
const _hoisted_17 = {
  class: "pic_list subject"
};
const _hoisted_18 = {
  class: "pic_list_info"
};
const _hoisted_19 = {
  class: "list01",
  id: "change_info"
};
const _hoisted_20 = {
  class: "totalsum"
};
const _hoisted_21 = {
  id: "search_total"
};
const _hoisted_22 = {
  key: 0,
  class: "totalsum"
};
const _hoisted_23 = {
  key: 0,
  id: "search_total"
};
const _hoisted_24 = {
  key: 1,
  class: "totalLoading"
};
const _hoisted_25 = {
  class: "pic_list_info2"
};
const _hoisted_26 = {
  id: "search_condition",
  class: "condition"
};
const _hoisted_27 = ["onClick"];
const _hoisted_28 = ["onClick"];
const _hoisted_29 = ["onClick"];
const _hoisted_30 = {
  onclick: "",
  target: "_blank"
};
const _hoisted_31 = {
  class: "img_box2"
};
const _hoisted_32 = ["src"];
const _hoisted_33 = ["src"];
const _hoisted_34 = {
  key: 1,
  id: "list",
  class: "list"
};
const _hoisted_35 = ["onClick"];
const _hoisted_36 = {
  onclick: "",
  target: "_blank"
};
const _hoisted_37 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, null, -1));
const _hoisted_38 = {
  key: 2,
  class: "nodata"
};
const _hoisted_39 = {
  key: 3,
  class: "loading"
};
const _hoisted_40 = {
  class: "detailcontent subject"
};
const _hoisted_41 = {
  class: "container clearfix"
};
const _hoisted_42 = {
  class: "banner"
};
const _hoisted_43 = {
  class: "swiper-container gallery-top"
};
const _hoisted_44 = {
  class: "swiper-wrapper",
  id: "bgImg"
};
const _hoisted_45 = ["onClick"];
const _hoisted_46 = ["src"];
const _hoisted_47 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "swiper-pagination"
}, null, -1));
const _hoisted_48 = {
  class: "smallbox"
};
const _hoisted_49 = {
  class: "swiper-container gallery-thumbs"
};
const _hoisted_50 = {
  class: "swiper-wrapper",
  id: "smImg"
};
const _hoisted_51 = ["src"];
const _hoisted_52 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "swiper-button-next"
}, null, -1));
const _hoisted_53 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "swiper-button-prev"
}, null, -1));
const _hoisted_54 = {
  class: "detailcon"
};
const _hoisted_55 = {
  id: "detailinfo"
};
const _hoisted_56 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "sp1"
}, "藏品编号", -1));
const _hoisted_57 = {
  key: 0
};
const _hoisted_58 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "sp1"
}, "年代", -1));
const _hoisted_59 = {
  key: 1
};
const _hoisted_60 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "sp1"
}, "分类", -1));
const _hoisted_61 = {
  key: 2
};
const _hoisted_62 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "sp1"
}, "质地", -1));
const _hoisted_63 = {
  key: 3
};
const _hoisted_64 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "sp1"
}, "外形尺寸", -1));
const _hoisted_65 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "sp1"
}, "完残程度", -1));
const _hoisted_66 = ["innerHTML"];
const _hoisted_67 = {
  class: "foot"
};
const _hoisted_68 = {
  key: 1,
  class: "bigImg"
};
const _hoisted_69 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_tree = _resolveComponent("el-tree");
  const _component_font = _resolveComponent("font");
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`collection ${$data.themeColor}`)
  }, [$data.themeColor ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("span", {
    class: "btn-screen ydshow ab",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.ydshowmenu && $options.ydshowmenu(...args))
  }, _hoisted_3), _createElementVNode("div", _hoisted_4, [_createElementVNode("a", {
    onClick: _cache[1] || (_cache[1] = (...args) => $options.toIndex && $options.toIndex(...args))
  }, [!$data.logoImg ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString($data.title), 1)) : (_openBlock(), _createElementBlock("img", {
    key: 1,
    src: $data.logoImg
  }, null, 8, _hoisted_6))])]), _createElementVNode("div", _hoisted_7, [_createElementVNode("img", {
    src: require(`../../assets/collection/title_t_${$data.themeColor}.png`)
  }, null, 8, _hoisted_8)]), _createElementVNode("div", {
    class: "ydshow searchbtn ab",
    onClick: _cache[2] || (_cache[2] = (...args) => $options.ydshowsearch && $options.ydshowsearch(...args))
  }), _withDirectives(_createElementVNode("div", _hoisted_9, [_withDirectives(_createElementVNode("input", {
    name: "topKeyword",
    "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $data.Keyword = $event),
    id: "topKeyword",
    type: "text",
    placeholder: "关键词搜索",
    class: "input03",
    onKeyup: _cache[4] || (_cache[4] = _withKeys($event => $options.topSearch(), ["enter"]))
  }, null, 544), [[_vModelText, $data.Keyword]]), _createElementVNode("input", {
    name: "",
    onClick: _cache[5] || (_cache[5] = $event => $options.topSearch()),
    class: "input04",
    value: "搜索"
  }), _createElementVNode("span", {
    class: "ydshow icon-close",
    onClick: _cache[6] || (_cache[6] = (...args) => $options.ydhidesearch && $options.ydhidesearch(...args))
  })], 512), [[_vShow, $data.ydsearch]])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_10, [$data.ydmenu ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "shadeBlock",
    onClick: _cache[7] || (_cache[7] = (...args) => $options.shadefun && $options.shadefun(...args))
  })) : _createCommentVNode("", true), _createElementVNode("div", {
    class: _normalizeClass(["menu", `${$data.ydmenu ? 'on' : ''} ${$data.themeColor}`])
  }, [_createElementVNode("div", {
    class: _normalizeClass(`newOpen ${$data.theme.needYear == 0 ? 'newOpenOnly' : ''}`)
  }, [_createElementVNode("div", {
    class: _normalizeClass(!$data.showIndex ? 'active' : ''),
    onClick: _cache[8] || (_cache[8] = $event => $data.showIndex = 0)
  }, "藏品分类", 2), $data.theme.needYear == 1 ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: _normalizeClass($data.showIndex ? 'active' : ''),
    onClick: _cache[9] || (_cache[9] = $event => $data.showIndex = 1)
  }, "年代", 2)) : _createCommentVNode("", true)], 2), _createElementVNode("div", _hoisted_11, [_withDirectives(_createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_createVNode(_component_el_tree, {
    ref: "tree",
    "node-key": "title",
    props: $data.props,
    data: $data.typeData,
    "empty-text": "加载中",
    "show-checkbox": "",
    onCheck: $options.handleCheckChange
  }, null, 8, ["props", "data", "onCheck"])])], 512), [[_vShow, !$data.showIndex]])]), _createElementVNode("div", _hoisted_14, [_withDirectives(_createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_createVNode(_component_el_tree, {
    ref: "tree2",
    "node-key": "title",
    props: $data.props,
    data: $data.eraData,
    "empty-text": "加载中",
    "show-checkbox": "",
    onCheck: $options.checkChangeEra
  }, null, 8, ["props", "data", "onCheck"])])], 512), [[_vShow, $data.showIndex]])])], 2), !$data.ldflag ? (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: "windowPlaceholder",
    onClick: _cache[10] || (_cache[10] = $event => $data.ldflag = true)
  })) : _createCommentVNode("", true), _createElementVNode("div", {
    class: _normalizeClass(["content", {
      'style1': !$data.ldflag
    }]),
    ref: "content",
    onScroll: _cache[16] || (_cache[16] = (...args) => $options.scrollEvent && $options.scrollEvent(...args))
  }, [_withDirectives(_createElementVNode("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, [_createElementVNode("ul", _hoisted_19, [_createElementVNode("li", {
    class: _normalizeClass({
      'on': $data.listImgFlag
    })
  }, [_createElementVNode("a", {
    href: "javascript:;",
    onClick: _cache[11] || (_cache[11] = $event => $options.changeType(true))
  })], 2), _createElementVNode("li", {
    class: _normalizeClass({
      'on': !$data.listImgFlag
    })
  }, [_createElementVNode("a", {
    href: "javascript:;",
    onClick: _cache[12] || (_cache[12] = $event => $options.changeType(false))
  })], 2)]), _createElementVNode("span", _hoisted_20, [_createTextVNode("共"), _createElementVNode("strong", _hoisted_21, " " + _toDisplayString($data.total), 1), _createTextVNode("套")]), $data.totalNum ? (_openBlock(), _createElementBlock("span", _hoisted_22, [$data.totalInfo.totalPage == $data.totalInfo.page ? (_openBlock(), _createElementBlock("strong", _hoisted_23, " " + _toDisplayString($data.totalNum), 1)) : (_openBlock(), _createElementBlock("span", _hoisted_24)), _createTextVNode("件  ")])) : _createCommentVNode("", true)]), _withDirectives(_createElementVNode("div", _hoisted_25, [_createElementVNode("span", _hoisted_26, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.checkedTree, (item, index) => {
    return _openBlock(), _createBlock(_component_font, {
      key: index
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(item.title), 1), _createElementVNode("a", {
        href: "javascript:;",
        onClick: $event => $options.removetype(index)
      }, null, 8, _hoisted_27)]),
      _: 2
    }, 1024);
  }), 128)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.checkedEra, (item, index) => {
    return _openBlock(), _createBlock(_component_font, {
      key: index
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(item.title), 1), _createElementVNode("a", {
        href: "javascript:;",
        onClick: $event => $options.removetype(index, 'era')
      }, null, 8, _hoisted_28)]),
      _: 2
    }, 1024);
  }), 128))]), _createElementVNode("a", {
    href: "javascript:;",
    class: "del",
    onClick: _cache[13] || (_cache[13] = $event => $options.removeAll())
  }, "清空全部")], 512), [[_vShow, $data.checkedTree.length || $data.checkedEra.length]]), $data.listImgFlag ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    id: "con",
    class: _normalizeClass(`${$data.theme.styleType == 2 ? 'con2' : ''}`)
  }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.List, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: _normalizeClass(`pic ${$data.theme.styleType == 2 ? 'pic2' : ''}`),
      key: index,
      onClick: $event => $options.godetail(item)
    }, [_createElementVNode("a", _hoisted_30, [_createElementVNode("div", _hoisted_31, [item.primaryImage ? (_openBlock(), _createElementBlock("img", {
      key: 0,
      class: "img001",
      src: item.primaryImage
    }, null, 8, _hoisted_32)) : _createCommentVNode("", true), !item.primaryImage && $data.themeColor ? (_openBlock(), _createElementBlock("img", {
      key: 1,
      src: require(`../../assets/collection/primary_${$data.themeColor}.png`)
    }, null, 8, _hoisted_33)) : _createCommentVNode("", true)]), _createElementVNode("p", null, _toDisplayString(item.antiqueName), 1)])], 10, _hoisted_29);
  }), 128))], 2)) : _createCommentVNode("", true), !$data.listImgFlag ? (_openBlock(), _createElementBlock("div", _hoisted_34, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.List, (item, index) => {
    return _openBlock(), _createElementBlock("dl", {
      key: index,
      onClick: $event => $options.godetail(item),
      style: _normalizeStyle({
        '--bgColor': $data.bgColor
      })
    }, [_createElementVNode("a", _hoisted_36, [_createElementVNode("dt", null, _toDisplayString(item.antiqueName), 1), _createElementVNode("dd", null, [_createElementVNode("span", null, _toDisplayString(item.antiqueCode), 1), _createElementVNode("span", null, _toDisplayString(item.texture), 1), _createElementVNode("span", null, _toDisplayString(item.era), 1), _hoisted_37])])], 12, _hoisted_35);
  }), 128))])) : _createCommentVNode("", true), $data.total == 0 && !$data.isLoading ? (_openBlock(), _createElementBlock("div", _hoisted_38, "暂无数据")) : _createCommentVNode("", true), $data.isLoading ? (_openBlock(), _createElementBlock("div", _hoisted_39, "加载中")) : _createCommentVNode("", true)], 512), [[_vShow, $data.ldflag]]), _withDirectives(_createElementVNode("div", _hoisted_40, [_createElementVNode("span", {
    class: "share",
    onClick: _cache[14] || (_cache[14] = (...args) => $options.golist && $options.golist(...args))
  }, "×"), _createElementVNode("div", _hoisted_41, [_createElementVNode("div", _hoisted_42, [_createElementVNode("div", _hoisted_43, [_createElementVNode("div", _hoisted_44, [_ctx.item !== '' ? (_openBlock(true), _createElementBlock(_Fragment, {
    key: 0
  }, _renderList($data.detail.bannerArr, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "swiper-slide",
      key: index,
      onClick: $event => $options.swipertop(item)
    }, [_createElementVNode("img", {
      src: item
    }, null, 8, _hoisted_46)], 8, _hoisted_45);
  }), 128)) : _createCommentVNode("", true)]), _hoisted_47]), _createElementVNode("div", _hoisted_48, [_createElementVNode("div", _hoisted_49, [_createElementVNode("div", _hoisted_50, [_ctx.item !== '' ? (_openBlock(true), _createElementBlock(_Fragment, {
    key: 0
  }, _renderList($data.detail.bannerArr, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "swiper-slide",
      key: index
    }, [_createElementVNode("img", {
      src: item
    }, null, 8, _hoisted_51)]);
  }), 128)) : _createCommentVNode("", true)])]), _hoisted_52, _hoisted_53])]), _createElementVNode("div", _hoisted_54, [_createElementVNode("h2", null, _toDisplayString($data.detail.antiqueName), 1), _createElementVNode("ul", _hoisted_55, [_createElementVNode("li", null, [_hoisted_56, _createElementVNode("span", null, _toDisplayString($data.detail.antiqueCode), 1)]), $data.detail.era ? (_openBlock(), _createElementBlock("li", _hoisted_57, [_hoisted_58, _createElementVNode("span", null, _toDisplayString($data.detail.era), 1)])) : _createCommentVNode("", true), $data.detail.antiqueTypename ? (_openBlock(), _createElementBlock("li", _hoisted_59, [_hoisted_60, _createElementVNode("span", null, _toDisplayString($data.detail.antiqueTypename), 1)])) : _createCommentVNode("", true), $data.detail.texture ? (_openBlock(), _createElementBlock("li", _hoisted_61, [_hoisted_62, _createElementVNode("span", null, _toDisplayString($data.detail.texture), 1)])) : _createCommentVNode("", true), $data.detail.detailSize != null && $data.detail.detailSize != '' ? (_openBlock(), _createElementBlock("li", _hoisted_63, [_hoisted_64, _createElementVNode("span", null, _toDisplayString($data.detail.detailSize), 1)])) : _createCommentVNode("", true), _createElementVNode("li", null, [_hoisted_65, _createElementVNode("span", null, _toDisplayString($data.detail.incompleteLevel), 1)])]), _createElementVNode("div", {
    class: "remark",
    id: "remark",
    innerHTML: $data.detail.remark
  }, null, 8, _hoisted_66), _createElementVNode("span", {
    class: "share shareMobile",
    onClick: _cache[15] || (_cache[15] = (...args) => $options.golist && $options.golist(...args))
  }, "×")])])], 512), [[_vShow, !$data.ldflag]]), _createElementVNode("div", _hoisted_67, [_createElementVNode("p", null, [_createElementVNode("span", null, _toDisplayString($data.antiquetitle), 1)])])], 34)]), $data.bigImg ? (_openBlock(), _createElementBlock("div", _hoisted_68, [_createElementVNode("div", {
    class: "closeBig",
    onClick: _cache[17] || (_cache[17] = $event => $data.bigImg = '')
  }, "×"), _createElementVNode("img", {
    src: $data.bigImg
  }, null, 8, _hoisted_69)])) : _createCommentVNode("", true)], 2);
}